import request from '@/utils/request'
import { v2Host } from '@/config/host'

export function uploadFile(data) {
  return request({
    url: `${v2Host}/upload/file`,
    method: 'post',
    data: data,
    headers: {
      // 'Content-Type': 'multipart/form-data;'
    },
  })
}
